import type { FC } from 'react';

import { getCombinedLinkFieldValueHref } from '@eneco/common/link';
import { StickyNav as SparkyStickyNav } from '@eneco/sparky';
import { ComponentProps } from '@sitecore/types/lib';
import { SideNavRendering } from '@sitecore/types/SideNav';

type Props = ComponentProps & SideNavRendering;

const StickyNav: FC<Props> = ({ fields }) => {
  const links = fields.items.map((item: { active: boolean; fields: { link: { value: { text: string; target: string; href: string } } } }) => ({
    active: item.active,
    href: getCombinedLinkFieldValueHref(item.fields.link.value),
    text: item.fields.link.value.text,
    target: item.fields.link.value.target,
  }));

  return <SparkyStickyNav links={links} />;
};

export { StickyNav };
export default StickyNav;
